<template>
  <UeModal name="content_asset_filter_modal" :title="action" @before-open="beforeOpen">
    <div class="content_asset_filters" v-if="content_asset">
      <div>
        <div class="mb-5">
          <p v-if="edit">
            Note that editing filters will reset any question or testimonial selections you have
            made.
          </p>
          <p v-else>
            If you’d like to create a report filtered by category, make the selection below. To
            create a report based on all responses, proceed without filtering.
          </p>
        </div>
        <div class="mb-5">
          <div class="filter_area">
            <Loader v-if="loading" />
            <b-tabs @input="setFilter" :value="filter_index" v-else>
              <b-tab v-for="filter in filters" :title="filterNames[filter]" :key="filter">
                <QuestionFilters
                  class="mt-2"
                  v-if="filter == 'question'"
                  :content-asset="content_asset"
                  :questions="content_asset.survey.questions"
                />
                <div class="mt-2" v-else>
                  <b-form-select :options="filter_options" v-model="filter_data" />
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
    <template v-slot:footer>
      <div class="w-100 d-flex justify-content-end">
        <b-button
          variant="secondary"
          class="mr-2"
          @click="$closeModal('content_asset_filter_modal')"
        >
          Cancel
        </b-button>
        <b-button variant="primary" :disabled="loading" @click="saveFilter()"> Continue </b-button>
      </div>
    </template>
  </UeModal>
</template>

<script lang="ts">
import axios from '@lib/apiClient'
import api from '@app/mixins/api.js'
import QuestionFilters from '@app/components/QuestionFilters.vue'
import { mapState } from 'pinia'
import { useContentAssetStore } from '@app/stores/ContentAssetStore.ts'

import Loader from '@app/components/Loader.vue'

export default {
  components: { Loader, QuestionFilters },
  mixins: [api],
  data() {
    return {
      loading: false,
      edit: false,
      content_asset: null,
      filter_data: null,
      filters: ['sector', 'company', 'size_group', 'seniority', 'recipient_role', 'question'],
      filterNames: {
        sector: 'Industry',
        company: 'Account',
        size_group: 'Company Size',
        seniority: 'Seniority',
        recipient_role: 'Role',
        question: 'Questions',
      },
    }
  },
  watch: {
    filter_data(value) {
      this.content_asset.filter_data = [value]
    },
  },
  computed: {
    ...mapState(useContentAssetStore, ['fetchContentAsset']),
    filter_index: {
      get() {
        return this.filters.indexOf(this.content_asset.filter)
      },
      set(value) {
        this.filter_index = value
      },
    },
    action() {
      return this.edit ? 'Edit Filters' : 'Create Report'
    },
    filter_options() {
      var filters = [{ value: null, text: 'All' }]

      var filter = this.content_asset.filter ? this.content_asset.filter : this.filters[0]
      if (filter == 'question') return
      return filters
        .concat(this.content_asset.survey[`${filter}_filters`])
        .filter((s) => s.count > 1)
        .map((f) => {
          return { value: f['id'], text: `${f['name']} (${f['count']})` }
        })
    },
  },
  methods: {
    setFilter(filter_index) {
      this.content_asset.filter = this.filters[filter_index]
      this.content_asset.filter_data = []
    },
    saveFilter() {
      this.loading = true
      var method, url
      if (this.content_asset.id) {
        method = 'patch'
        url = `/app/api/content_assets/${this.content_asset.id}/set_filter.json`
      } else {
        method = 'post'
        url = '/app/api/content_assets.json'
        this.content_asset.type = 'SurveySpotlightAsset'
        this.content_asset.assetable_id = this.content_asset.survey_id
        this.content_asset.assetable_type = 'Survey'
      }
      axios({
        url: url,
        method: method,
        data: {
          content_asset: this.content_asset,
        },
      }).then((r) => {
        if (this.edit) {
          // we do this just to update the store with 'filtered_by', which is calculated
          // on the server
          this.fetchContentAsset(this.content_asset.id)
          this.$closeModal('content_asset_filter_modal')
        } else {
          this.$router.push({
            path: `/app/content_assets/${r.data.content_asset.id}/create`,
          })
        }
      })
    },
    beforeOpen(e) {
      this.loading = false
      this.edit = e.params.edit
      this.content_asset = e.params.content_asset
      this.filter_data = this.content_asset.filter_data[0]
    },
  },
}
</script>
<style lang="sass" scoped>
.loader
  margin: 0 auto
  width: 100%
.content_asset_filters
::v-deep .nav-tabs
  border-bottom: inherit !important
  a
    color: black !important
    &.active
      color: var(--uePurple) !important
</style>
